module.exports = __webpack_public_path__ + "img/02.67d31672.png";